"use client";
import React, { useState } from "react";
import { usePassword } from "../../context/PasswordContext";
import { Eye, EyeOff } from "lucide-react";
export default function ChangePassword() {
  const { changePassword, loading } = usePassword();

  const [form, setForm] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  const [errors, setErrors] = useState({});
  const [successMsg, setSuccessMsg] = useState("");
const [showPassword, setShowPassword] = useState({
  old: false,
  new: false,
  confirm: false,
});
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({});
    setSuccessMsg("");
  };

  const validate = () => {
    const newErrors = {};

    if (!form.old_password) newErrors.old_password = "Old password is required";
    if (!form.new_password) newErrors.new_password = "New password is required";
    if (form.new_password.length < 6)
      newErrors.new_password = "Password must be at least 6 characters";
    if (form.new_password !== form.confirm_password)
      newErrors.confirm_password = "Passwords do not match";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const res = await changePassword({
      old_password: form.old_password,
      new_password: form.new_password,
    });

    if (res.success) {
      setSuccessMsg("Password updated successfully");
      setForm({
        old_password: "",
        new_password: "",
        confirm_password: "",
      });
    }
  };

  return (
    <div className="bg-sky-50 min-h-screen px-6 py-6 sm:px-9">
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-5">
        Settings
      </h1>

      <div className="bg-white rounded-2xl shadow-sm p-6 max-w-full">
        <h2 className="text-lg font-semibold mb-4 text-gray-800">
          Change Password
        </h2>

        {successMsg && (
          <div className="mb-4 text-sm text-green-700 bg-green-100 px-3 py-2 rounded">
            {successMsg}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Old Password */}
         <div className="relative">
  <label className="text-sm text-gray-700">Old Password</label>

  <input
    type={showPassword.old ? "text" : "password"}
    name="old_password"
    value={form.old_password}
    onChange={handleChange}
    className="mt-1 w-full border rounded-lg px-3 py-2 text-sm pr-10 outline-none focus:ring-2 focus:ring-indigo-500"
  />

  <span
    onClick={() =>
      setShowPassword((prev) => ({ ...prev, old: !prev.old }))
    }
    className="absolute right-3 top-9 cursor-pointer text-gray-500"
  >
    {showPassword.old ? <EyeOff size={18} /> : <Eye size={18} />}
  </span>
</div>

          {/* New Password */}
        <div className="relative">
  <label className="text-sm text-gray-700">New Password</label>

  <input
    type={showPassword.new ? "text" : "password"}
    name="new_password"
    value={form.new_password}
    onChange={handleChange}
    className="mt-1 w-full border rounded-lg px-3 py-2 pr-10 text-sm outline-none focus:ring-2 focus:ring-indigo-500"
  />

  <span
    onClick={() =>
      setShowPassword((prev) => ({ ...prev, new: !prev.new }))
    }
    className="absolute right-3 top-9 cursor-pointer text-gray-500"
  >
    {showPassword.new ? <EyeOff size={18} /> : <Eye size={18} />}
  </span>

  {errors.new_password && (
    <p className="text-xs text-red-600 mt-1">{errors.new_password}</p>
  )}
</div>

          {/* Confirm Password */}
        <div className="relative">
  <label className="text-sm text-gray-700">Confirm Password</label>

  <input
    type={showPassword.confirm ? "text" : "password"}
    name="confirm_password"
    value={form.confirm_password}
    onChange={handleChange}
    className="mt-1 w-full border rounded-lg px-3 py-2 pr-10 text-sm outline-none focus:ring-2 focus:ring-indigo-500"
  />

  <span
    onClick={() =>
      setShowPassword((prev) => ({
        ...prev,
        confirm: !prev.confirm,
      }))
    }
    className="absolute right-3 top-9 cursor-pointer text-gray-500"
  >
    {showPassword.confirm ? <EyeOff size={18} /> : <Eye size={18} />}
  </span>

  {errors.confirm_password && (
    <p className="text-xs text-red-600 mt-1">
      {errors.confirm_password}
    </p>
  )}
</div>

          <div className="pt-4 flex justify-end">
            <button
              type="submit"
              disabled={loading}
              className=" text-white px-6 py-2 rounded-lg text-sm font-medium disabled:bg-gray-400"
          style={{
background: "linear-gradient(135deg, #2563eb, #d12465)"
}}  >
              {loading ? "Updating..." : "Update Password"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
